module.exports = __webpack_public_path__ + "img/4_126.1a0529c0.png";